<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Settings"
                        sub-title="Edit location settings"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                     <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                        Save
                    </app-button>

                    <app-button v-if="location" element="a" class="btn  btn--secondary  btn--secondary--sml ml-4" @click="$router.push({ name: 'locations.home', params: { id: 5 } })">
                        Cancel
                    </app-button>
                </div>
            </div>

            <app-tabs-wrapper default="opening-hours" :loading="loading" :initial="loading" class="mb-8">
                <div class="w-full flex items-center border-b-2 border-grey-lighter" slot-scope="{ toggle, active }">
                    <app-tabs-trigger name="opening-hours" :handle-click="toggle" :active="active">Opening hours</app-tabs-trigger>
                    <app-tabs-trigger name="address" :handle-click="toggle" :active="active">Address</app-tabs-trigger>
                    <app-tabs-trigger name="booking" :handle-click="toggle" :active="active">Booking</app-tabs-trigger>
                </div>

                <div slot="items" slot-scope="{ active }">
                    <app-tabs-content name="opening-hours" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Monday"
                                    v-model="fields.opening_hours.monday"
                                    :error="errors.monday"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Tuesday"
                                    v-model="fields.opening_hours.tuesday"
                                    :error="errors.tuesday"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Wednesday"
                                    v-model="fields.opening_hours.wednesday"
                                    :error="errors.wednesday"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Thursday"
                                    v-model="fields.opening_hours.thursday"
                                    :error="errors.thursday"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Friday"
                                    v-model="fields.opening_hours.friday"
                                    :error="errors.friday"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Saturday"
                                    v-model="fields.opening_hours.saturday"
                                    :error="errors.saturday"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Sunday"
                                    v-model="fields.opening_hours.sunday"
                                    :error="errors.sunday"
                                />
                            </div>
                        </div>
                    </app-tabs-content>
                    <app-tabs-content name="address" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Address line 1"
                                    v-model="fields.address.line_1"
                                    :error="errors.line_1"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Address line 2"
                                    v-model="fields.address.line_2"
                                    :error="errors.line_2"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="City"
                                    v-model="fields.address.city"
                                    :error="errors.city"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="County"
                                    v-model="fields.address.county"
                                    :error="errors.county"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Postcode"
                                    v-model="fields.address.postcode"
                                    :error="errors.postcode"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Country"
                                    v-model="fields.address.country"
                                    :error="errors.country"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Directions"
                                    v-model="fields.address.directions"
                                    :error="errors.directions"
                                />
                            </div>
                        </div>

                        <div class="block my-8 w-full bg-grey-light" style="height: 1px;"></div>

                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Latitude"
                                    v-model="fields.geo.lat"
                                    :error="errors.lat"
                                />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Longitude"
                                    v-model="fields.geo.lng"
                                    :error="errors.lng"
                                />
                            </div>
                        </div>
                    </app-tabs-content>
                    <app-tabs-content name="booking" :active="active">
                        <div class="flex flex-wrap -mx-2">
                            <div class="w-full px-2">
                                <app-field-text
                                    label="Booking Calendar Delay"
                                    v-model="fields.booking.delay"
                                    :error="errors.delay"
                                />
                            </div>
                        </div>
                    </app-tabs-content>
                </div>
            </app-tabs-wrapper>
        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import SelectField from '@/components/fields/inputs/Select';
    import TextField from '@/components/fields/inputs/Text';
    import CategoryField from '@/components/fields/inputs/Category';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import TextareaField from '@/components/fields/inputs/Textarea';
    import DateTimeField from '@/components/fields/inputs/DateTime';
    import TrixField from '@/components/fields/inputs/Trix';
    import CurrencyField from '@/components/fields/inputs/Currency';
    import RepeatableField from '@/components/fields/inputs/Repeatable';
    import FileField from '@/components/fields/inputs/File';
    import TabsWrapper from '@/components/tabs/Wrapper';
    import TabsTrigger from '@/components/tabs/Trigger';
    import TabsContent from '@/components/tabs/Content';
    import SEO from '@/components/SEO';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'locations.edit',

        data: () => ({
            location: 26,
            fields: {
                location_id: '',
                description: '',
                image: '',
                responsetap_number: '',
                rt_hidden_number: '',
                trustpilot: '',
                google_tour: '',
                opening_hours: {
                    monday: '',
                    tuesday: '',
                    wednesday: '',
                    thursday: '',
                    friday: '',
                    saturday: '',
                    sunday: '',
                },
                address: {
                    line_1: '',
                    line_2: '',
                    city: '',
                    county: '',
                    postcode: '',
                    country: '',
                },
                booking: {
                  delay: '',
                },
                geo: {
                    lat: '',
                    lng: '',
                },
                google_reviews_data: {
                    place_id: '',
                    published: false
                }
            },
            items: {
                locations: []
            },
            loading: false,
            errors: {}
        }),

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-field-select': SelectField,
            'app-field-text': TextField,
            'app-field-category': CategoryField,
            'app-field-toggle': ToggleField,
            'app-field-textarea': TextareaField,
            'app-field-datetime': DateTimeField,
            'app-field-trix': TrixField,
            'app-field-currency': CurrencyField,
            'app-field-repeatable': RepeatableField,
            'app-field-file': FileField,
            'app-tabs-wrapper': TabsWrapper,
            'app-tabs-trigger': TabsTrigger,
            'app-tabs-content': TabsContent,
            'app-seo-widget': SEO
        },

        mixins: [
            ValidationErrors
        ],

        mounted() {
            if (typeof this.$route.params.id != 'undefined') {
                this.loading = true;

                this.getLocations()
                    .then(response => {
                        this.getLocation(this.$route.params.id)
                            .then(response => {
                                for (let index in this.location) {
                                    if (typeof this.fields[index] !== 'undefined' || index == 'place_id' || index == 'google_reviews_published') {
                                        switch (index) {
                                            case 'place_id':
                                                this.fields.google_reviews_data.place_id = (this.location[index] != null ? this.location[index] : '');
                                                break;

                                            case 'google_reviews_published':
                                                this.fields.google_reviews_data.published = (this.location[index] != null ? this.location[index] : '');
                                                break;

                                            default:
                                                if (index != 'google_reviews') {
                                                    this.fields[index] = this.location[index];
                                                }
                                        }
                                    }
                                }
                            })
                            .catch(error => {
                                this.$router.push({
                                  name: 'locations.edit',
                                  params: { id: 5 }
                              });
                            });
                    })
                    .then(response => {
                        this.loading = false;
                    });
            } else {
                this.$router.push({
                      name: 'locations.edit',
                      params: { id: 5 }
                  });
            }
        },

        computed: {
            ...mapGetters({

            })
        },

        methods: {
            getLocations() {
                return Api.request('get', `locations/locations`)
                    .then(({ data }) => {
                        this.items.locations = data.locations;
                    });
            },
            getLocation(id) {
                return Api.request('get', `locations/edit/${id}`)
                    .then(({ data }) => {
                        this.location = data.location;
                    });
            },
            save() {
                this.loading = true;
                this.clearErrors();

                return Api.request('post', `locations/update/${this.location.id}`, this.fields).then(response => {
                    if(typeof response.data.message != 'undefined') {
                        this.$toasted.show(response.data.message, {
                            type: "success",
                            position: "bottom-right",
                            duration : 5000
                        });
                    }
                    if(typeof response.data.id != 'undefined') {
                        this.$router.push({
                            name: 'locations.edit',
                            params: { id: 5 }
                        });
                    }
                }).catch(error => {
                    if(this.hasErrors(error)) {
                        this.addErrors(error);
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/locations/Edit.vue